
<div style="margin-top: 24px;">
  <div *ngIf="(viewModel$ | async) as viewModel" class="page-content" style="height: calc(100vh + 1px)">
    <div #appointmentListScrollContainer
         infinite-scroll
         class="search-results"
         [scrollWindow]="true"
         [infiniteScrollUpDistance]="1.5"
         [infiniteScrollDistance]="1.5"
         [infiniteScrollThrottle]="150"
         (scrolled)="onScrollDown($event)"
         [immediateCheck]="true"
    >

    <p-table #appointmentListTable
             class="appointmentTable table table-condensed table-hover table-fixed-header"
             dataKey="appointmentId"
             [(selection)]="selectedAppointment"
             selectionMode="single"
             [rowHover]="true"
             [value]="appointments"
             [rowExpandMode]="pinnedAppointments.length === 0 ? 'single': ''"
             [expandedRowKeys]="expandedRows"
             sortField="appointmentTimeMs"
    >
      <ng-template pTemplate="header" let-columns>
        <tr class="table-header-upper-row">
          <th class="th-upper" style="min-width: 210px; width: 15%; padding-left: 25px;">
            Appointment time
          </th>
          <th class="th-upper" style="min-width: 220px; width:15%;">{{'_PatientName_'| translate}}</th>
          <th class="th-upper" style="min-width: 200px; width:15%;">Appointment Status</th>
          <th class="th-upper" style="min-width: 200px; width:15%;"
              *ngIf="viewModel.showProviders && viewModel.providers.length > 0">Provider
            <span class="th-upper"
                  *ngIf="viewModel.showProviders && viewModel.locations.length > 0"> / Location</span>
          </th>
          <th class="th-upper" style="min-width: 220px; width:15%;">Reminder Status</th>
          <th class="th-upper" style="min-width: 200px; width: 25%">Reminder Strategy</th>
        </tr>
        <tr class="table-header-lower-row">
          <th style="min-width: 210px; width: 15%;">
            <div class="input-group">

              <div *ngIf="urlType === 'appointment'" style="padding: 0px 1px 11px 16px;">
                <input type="text"
                       class="form-control"
                       (bsValueChange)="getAppointmentByDate($event)"
                       #datePicker="bsDatepicker"
                       [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false , selectFromOtherMonth: true}"
                       bsDatepicker [(ngModel)]="fromDate"
                       style="width: 90px;"
                >
                <span style="width: 20px">
                <button type="button" class="btn btn-default" (click)="toggle(datePicker)"
                        style="height: 23px;
                                margin-left: -4px;
                                padding-top: 4px;
                                font-size: 11px;
                                width: 32px;">
                      <i class="pi pi-calendar" ></i>
                </button>
                </span>
              </div>

              <div *ngIf="urlType === 'patient'"  style="padding: 0px 12px;">
                <input type="text"
                       class="form-control"
                       (bsValueChange)="getAppointmentByPatient($event)"
                       #bsDaterangepicker="bsDaterangepicker"
                       [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', rangeInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false , selectFromOtherMonth: true}"
                       bsDaterangepicker
                       [(ngModel)]="patientDateRange"
                       style="width: 145px;"
                >
                <span style="width: 20px">
                <button type="button" class="btn btn-default"
                        (click)="toggle(bsDaterangepicker)"
                        style="height: 23px;
                                margin-left: -4px;
                                padding-top: 4px;
                                font-size: 11px;
                                width: 32px;">
                      <i class="pi pi-calendar" ></i>
                </button>
                </span>
              </div>
              <br/>
            </div>
          </th>

          <th class="th-lower" style="width: 15%; min-width: 220px;"></th>

          <th class="th-lower" style="width: 15%; min-width: 200px;">
            <p-multiSelect
                [panelStyle]="{minWidth:'100%'}"
                [options]="appointmentStatus"
                [(ngModel)]="selectedAppointmentStatus"
                (onChange)="appointmentListTable.filter($event.value, 'remoteAppointmentState', 'in');"
                [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                'padding-left': '16px', 'text-shadow': 'none', 'outline': 'none', 'font-size': '12px'}">
              <p-header style="color: black; position: fixed; margin-left: 21px; font-size: 12px" (click)="selectedDeselectedAppointmentStatus()" >
                Select / Deselect All
              </p-header>
              <ng-template let-stateItems pTemplate="selectedItems">
                <span *ngIf="stateItems && stateItems.length > 0"
                      class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">{{stateItems.length}} selected</span>
                <span *ngIf="selectedAppointmentStatus && selectedAppointmentStatus.length === 0"
                      class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">-- Select --</span>
              </ng-template>
              <ng-template let-appointmentState pTemplate="item">
                <span class="user-scheduler-status-item" style="font-size: 12px">{{appointmentState.label}}
                </span>
              </ng-template>
            </p-multiSelect>
          </th>

          <th class="th-lower" *ngIf="viewModel.showProviders && viewModel.providers.length > 0" style="width: 15%; min-width: 200px;">
              <p-multiSelect
                  [panelStyle]="{minWidth:'100%'}"
                  [options]="providers"
                  [(ngModel)]="selectedProviders"
                  (onChange)="onProviderChange($event.value, viewModel.showProviders)"
                  [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                'padding-left': '16px', 'text-shadow': 'none', 'font-size': '12px'}">
              <p-header style="color: black;position: fixed; margin-left: 21px; font-size: 12px" (click)="selectedDeselectedProviders()">
                Select / Deselect All
              </p-header>
              <ng-template let-providerItems pTemplate="selectedItems">
                  <span *ngIf="providerItems && providerItems.length > 0"
                        class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">{{providerItems.length}} selected</span>
                <span *ngIf="selectedProviders && selectedProviders.length === 0"
                      class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">-- Select --</span>
              </ng-template>
              <ng-template let-providers pTemplate="item">
                <span class="user-scheduler-status-item" style="font-size: 12px">{{providers.label}}</span>
              </ng-template>
            </p-multiSelect>

            <br/>
            <div class="th-lower" style="padding-left: 0;"
                *ngIf="viewModel.showProviders && viewModel.locations.length > 0">
              <p-multiSelect
                  [panelStyle]="{minWidth:'100%'}"
                  [options]="locationsItem"
                  [(ngModel)]="selectedLocations"
                  (onChange)="onLocationsChange($event.value, viewModel.showProviders, viewModel.locations);"
                  [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color': '#337ab7',
                    'padding-left': '16px', 'text-shadow': 'none', 'font-size': '12px'}">
                <p-header style="color: black;position: fixed;margin-left: 21px; font-size: 12px" (click)="selectedDeselectedLocation()">
                  Select / Deselect All
                </p-header>
                <ng-template let-locationItems pTemplate="selectedItems">
                    <span *ngIf="locationItems && locationItems.length > 0"
                          class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">{{locationItems.length}} selected</span>
                  <span *ngIf="selectedLocations && selectedLocations.length === 0"
                        class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">-- Select --</span>
                </ng-template>
                <ng-template let-locations pTemplate="item">
                      <span class="user-scheduler-status-item" style="font-size: 12px">{{locations.label}}
                      </span>
                </ng-template>
              </p-multiSelect>
            </div>
          </th>

          <th class="th-lower" style="width: 15%; min-width: 200px;">
            <p-multiSelect
                [options]="reminderStates"
                (onChange)="appointmentListTable.filter($event.value, 'reminderState', 'in')"
                [(ngModel)]="selectedReminderStates"
                [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                'padding-left': '16px', 'text-shadow': 'none', 'font-size': '12px'}"
            >
              <p-header style="color: black;position: fixed;margin-left: 21px; font-size: 12px" (click)="selectedDeselectedReminderState()">
                Select / Deselect All
              </p-header>
              <ng-template let-value pTemplate="selectedItems">
              <span *ngIf="value && value.length > 0"
                    class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">{{value.length}} selected</span>
                <span *ngIf="selectedReminderStates && selectedReminderStates.length === 0"
                      class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">-- Select --</span>
              </ng-template>
              <ng-template let-reminderStates pTemplate="item">
                <span class="user-scheduler-status-item" style="font-size: 12px">{{reminderStates.label}}
                </span>
              </ng-template>
            </p-multiSelect>
          </th>

          <th class="th-lower" style="width: 15%; min-width: 200px;">
            &nbsp;
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-appointment let-columns="columns">
        <tr [pSelectableRow]="appointment"
            class="table-row ui-selectable-row"
            (mouseover)="showBubble = true; hoverAppointmentId = appointment.appointmentId; hoverGroupMasterAppointmentId = appointment.groupMasterId"
            (mouseleave)="showBubble = false; hoverAppointmentId = undefined; hoverGroupMasterAppointmentId = undefined"
            [ngClass]="{ 'hovered-group': isHoveredGroup(appointment), 'selected-group': isSelectedGroup(appointment.groupMasterId) }"
            *ngIf="appointment.remoteAppointmentState !== null && (appointment.remoteAppointmentState.toLowerCase() !== 'void' ||
                    (appointment.remoteAppointmentState.toLowerCase() === 'void' && viewModel.viewVoidAppointments))
"
        >
          <td style="min-width: 210px; width:15%; vertical-align: middle;">
            <div style="color: white;"
                 class="appointmentIcons text-right">
              <button (click)="showAppointmentLog(appointment, 0, '')"
                      tooltip="{{'_appointmentList_eventLog_' | translate}}"
                      *ngIf="viewModel.isAuthenticatedFromAdmin && ((showBubble && hoverAppointmentId === appointment.appointmentId) ||
                          (selectedAppointment !== undefined && selectedAppointment.appointmentId === appointment.appointmentId))"
                      style="background-color: #f47923; margin-right: 6px;" type="button" class="btn btn-default"
                      [ngClass]="{'appointmentAdminIcons' : viewModel.isAuthenticatedFromAdmin}"
              >
                <span class="fa fa-code" aria-hidden="true"></span>
              </button>
              <!-- NOTE: The appointment attribute directive is necessary to trigger opening on remoteAppointmentId set in the path -->
              <button (click)="getAppointmentDetails(appointment); "
                      [disabled]= "isPinedAppointment(appointment.appointmentId)"
                      [pRowToggler]="appointment"
                      [tooltip]="isOpenedAppointment(appointment.appointmentId)"
                      style="background-color: #1ba3e0; color: #ffffff; width: 16px; height: 16px"
                      type="button"
                      class="btn btn-default">
                <span class="fa fa-comment" aria-hidden="true"></span>
              </button>
            </div>


            <span style="font-size: 12px; color: #555;">
                {{appointment.appointmentTimeMs | amDateFormat: 'MM/DD/YYYY h:mm a'}}</span>
          </td>
          <td style="vertical-align: middle; font-size: 12px; min-width: 220px; width:15%;">
            <ng-template [featureFlags]="['resource:pets']" [featureFlagsElse]="patient_content">
              <a [routerLink]="['/clients']" [queryParams]="{clientid: appointment.personId}"
                  style="margin-right: 25px; width: 120px; text-align: left;" (click)="setPatientId(appointment.personId)">{{appointment.firstName}} {{appointment.middleName}}
                {{appointment.lastName}}
              </a>
              <span *ngIf="appointment.petDetails !== undefined">
                <br/><span tooltip="{{appointment.petDetails.breed}}">{{appointment.petDetails.petName}} ({{appointment.petDetails.species}})</span>
              </span>
            </ng-template>
<!--            ELSE IF IS NOT VETTER-->
            <ng-template #patient_content>
              <a [routerLink]="['/patients']" [queryParams]="{patientid: appointment.personId}"
                 style="margin-right: 25px; width: 120px; text-align: left;" (click)="setPatientId(appointment.personId)">{{appointment.firstName}} {{appointment.middleName}}
                {{appointment.lastName}}
              </a>
            </ng-template>

            <img
                style="/*background-color: #337AB7;*/ border-radius: 50%; height: 20px; margin-right: 16px; float: right; width: 20px;"
                *ngIf="appointment.hasBirthdayToday && viewModel.displayBirthday"
                src="/img/icon_birthday.png">

            <span *ngFor="let mediaType of getMediaTypes(appointment.mediaTypes)">
                <img style="height: 20px; /* background-color: #e20404; */ float: right; width: 20px;"
                     *ngIf="viewModel.displayIncorrectDestinator"
                     src="img/media_missing_{{mediaType.mediaType}}.png" tooltip="{{'_AppointmentList_tooltip_by_destinatortype_' |
                              translate : { 'destinatortype': (getDestinatorsForToolTip(appointment.mediaTypes, mediaType.mediaType)) } }}"
                >
            </span>
            <a
                href="#"
                [routerLink]="['/two-way']"
                [queryParams]="{destinatorid: appointment.destinatorId, personid: appointment.personId}"
                *ngIf="viewModel.displayTwoway && appointment.hasUnreadMessage">
              <img tooltip="{{'_appointmentList_twoWay_' | translate}}" alt=""
                   src="/img/icon_two-way.png" style="width:20px; margin-right: 6px; float: right; height: 20px"/>
            </a>


          </td>
          <td style="vertical-align: middle; font-size: 12px; min-width: 200px; width:15%;">{{appointment.remoteAppointmentState}} <span
              *ngIf="appointment.remoteAppointmentState==='scheduled' && appointment.appointmentState==='confirmed'">(confirmed)</span>
          </td>
          <td style="vertical-align: middle; font-size: 12px;min-width: 200px; width:15%; padding-left: 7px;"
              *ngIf="viewModel.showProviders && viewModel.providers.length > 0">
            <span style="font-size: 12px">{{appointment.providerName}}</span>
            <span style="vertical-align: middle; font-size: 12px; width: 200px; color: #337ab7"
                       *ngIf="viewModel.showProviders && viewModel.locations.length > 0 "><br/>{{appointment.location}}</span>
          </td>
          <td style="vertical-align: middle; min-width: 230px; width:15%;">
          <span style="width: 6px; height: 6px; margin-left: 4px;
            display:inline-block; border-radius: 50%;"
                [ngStyle]="getColorByStatus((appointment.reminderState !== null ? appointment.reminderState : ''))"></span>&nbsp;
            <span
                tooltip="{{'_ReminderState_' + appointment.reminderStateDetail + '_' | translate}}"
                style="font-size: 12px">{{'_ReminderState_' + (appointment.reminderState !== null ? appointment.reminderState : '') + '_' | translate}}</span>
            <span *ngIf="appointment.schedulerPending"
                  tooltip="{{'_appointmentList_scheduler_process_' | translate}}"
                  style="font-size: 10px; color: #ff0000">(strategy change pending)</span>
            <!-- img *ngIf="appointment.groupMasterId !==  undefined &&
                        appointment.groupMasterId !== null" tooltip="{{'_appointmentList_group_description_' | translate}}"
                 src="" style="padding-left: 10px;" / -->
            <span *ngIf="appointment.groupMasterId !==  undefined &&
                        appointment.groupMasterId !== null"
                  tooltip="{{'_appointmentList_group_description_' | translate}}"
                  style="padding-left: 10px; font-size: 8px;"> Group </span>
          </td>
          <td style="vertical-align: middle; min-width: 200px; width:25%;"
              [ngClass]="{warning : appointment.strategyId !== null && strategyDeleted(appointment.strategyId)}">
            <span style="font-size: 12px"
                  tooltip="{{'_Strategy_' + appointment.strategyType + '_' | translate}}">{{displayStrategyName(appointment.strategyId)}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-appointment let-columns="columns">
        <tr class="appointmentDetails">
          <td [attr.colspan]="reminderColspan"
              style="border-top: 0; padding: 0; padding-right: 16px;">
            <div style="padding-right: 15px; padding-left: 15px; background: #ffffff;" class="row">
              <div class="appointmentDetailsContent col-md-12">
                <div
                    style="font-size: x-large; font-family: 'Play', sans-serif; vertical-align: middle; margin-top: 0; margin-bottom: 6px;">
              <span style="background-color: #1ea5e1; padding: 0 4px 2px 4px; font-size: smaller; border-radius: 5px;">
                <i style="color: white; font-size: 20px" class="fa fa-comment"></i>
              </span>&nbsp;
                  Reminder Report
                  <img
                      *ngIf="!appointment.reminderReportLoaded &&
                      (selectedAppointment !== undefined && (selectedAppointment.appointmentId === appointment.appointmentId ||
                        selectedAppointment.groupMasterId === appointment.appointmentId))"
                      style="width: 30px; padding-left: 2px; margin-top: -3px; margin-left: 2px;"
                      src="/img/loading.gif" alt=""/>

                  <div class="pinIcons">
                    <button class="close" style="float: left; padding-top: 0; padding-right: 4px"
                            tooltip="{{isPinedAppointment(appointment.appointmentId) ? 'Unpin the report' : ' Pin the report '}}"
                            (click)="pinAppointment(appointment.appointmentId)"
                            [ngClass]="{'active' : isPinedAppointment(appointment.appointmentId)}">
                      <i style="font-size: 14px;" class="glyphicon glyphicon-pushpin"></i></button>
                    <button tooltip="{{'_appointmentList_close_report_' | translate}}"
                            class="close"
                            [pRowToggler]="appointment"
                            (click)="closeAppointment(appointment.appointmentId)"><i style="font-size: 14px;" class="pi pi-times"></i></button>
                  </div>
                </div>


                <div *ngIf="appointment.schedulerPending" class="alert alert-warning" role="warning" style="margin-top: 16px;">The scheduler is in
                  the process of updating reminders...
                </div>
                <div class="col-md-12" style="padding-right: 36px; padding-bottom: 6px; font-size: 16px; width: 100%"
                     *ngIf="appointment.reminderStateDetail !== undefined">
                  <span>{{'_ReminderState_' + appointment.reminderStateDetail + '_' | translate}}</span>
                </div>
                <span *ngIf="appointment.groupMasterId !==  undefined &&
                        appointment.groupMasterId !== null"
                      class="col-md-12" style="padding-right: 36px; padding-bottom: 6px; font-size: 16px; width: 100%">
                  {{'_appointmentList_group_description_' | translate}}

                 <span *ngIf="urlType === 'patient' && appointment.groupMasterId !==  undefined &&
                            appointment.groupMasterId !== null && appointment.groupMasterId !== appointment.appointmentId">
                            <a
                                [routerLink]="['/appointments']" [queryParams]="{appointmentid: appointment.groupMasterId}"
                                style="margin-right: 25px; margin-left: 6px; width: 120px; text-align: left;"
                            ><i class="glyphicon glyphicon-eye-open"></i></a>
                          </span>

                </span>
                <div class="col-md-12" style="padding-right: 36px"  *ngIf="appointment.reminderReportLoaded">
                  <table style="width: 100%;" class="reminderRows"
                         *ngIf="appointment.reminders && appointment.reminders.length > 0"

                  >
                    <tr *ngFor="let reminder of appointment.reminders | orderBy : 'reminderTimeMs': false">
                      <div *ngIf="(reminder.status === undefined ||
                                (reminder.status.toLowerCase() === 'deleted' && viewModel.viewDeletedReminders) ||
                                (reminder.status.toLowerCase() !== 'deleted'))">
                        <td style="height: 50px; min-width: 50px; vertical-align: middle; padding-top: 2px"
                            class="text-center">

                          <img style="height: 50px; max-width: 50px;" alt=""
                               *ngIf="viewModel.isAuthenticatedFromAdmin "
                               src="img/icons/media-{{reminder.type}}.png"
                               (click)="showAppointmentLog(appointment, 2, reminder)"
                               tooltip="{{'_appointmentList_show_appointment_details_' | translate}}">
                          <img style="height: 50px;" alt=""
                               *ngIf="!viewModel.isAuthenticatedFromAdmin"
                               src="img/icons/media-{{reminder.type}}.png">
                        </td>
                        <td style="padding-left: 10px; padding-bottom: 10px; width: 100%">
                          <!-- #caseId:{{reminder.caseId}}#reminder.type={{reminder.type}}#<br/-->
                          <br/>
                          <span
                              style="font-size: 13px;">{{'_ReminderCase_' + reminder.caseId + '_' + reminder.type + '_' |
                              translate : {
                              '0': getOffsetText(reminder.templateId, reminder.offsetFixed, reminder.offsetRelative, reminder.offsetText),
                              '1': ((reminder.isConfirmation ? '_MessageType_confirm_' : '_MessageType_reminder_') | translate),
                              '2': (reminder.address !== undefined ? reminder.address : ''),
                              '3': (reminder.reminderTimeMs | amDateFormat: 'MM/DD/YYYY h:mm a'),
                              '4': (reminder.originalTriggerTimeMs | amDateFormat: 'MM/DD/YYYY h:mm a'),
                              '5': (reminder.incorrectMediaType ? ('_destinatorType_' + reminder.incorrectMediaType + '_' | translate) : '')
                          } }}
                            </span>
                          <!-- Temporary solution because ng-bind-html filters out ng-click -->
                          <span *ngIf="(reminder.gatewayTrackingCode !== undefined ||  reminder.messageUuid !== undefined) && (reminder.status !== 'Failed' || reminder.status !== 'failed')">
                            <a (click)="previewByTrackingCode(reminder.gatewayTrackingCode, reminder.type, reminder.messageUuid, 'autoremind')">
                              <i class="glyphicon glyphicon-eye-open"></i></a>.
                          </span>
                          <span *ngIf="reminder.status === 'Failed' || reminder.status === 'failed'">The message failed.</span>

                        </td>
                      </div>
                    </tr>
                  </table>
                  <div *ngIf="!appointment.reminders ||  (appointment.reminders && appointment.reminders.length === 0)" class="alert alert-danger" role="alert">No reminders sent.</div>
                </div>
                <hr>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div style="height: 32px" *ngIf="loading && !isReminderRequest">
      <img src="/img/loading.gif" style="width: 32px;" />
    </div>
  </div>

  </div>
</div>




